import Product from "../../../../../../@types/Product";


const LsvKit_2024: Product = {
    id: 1,
    name: 'LSV Kit',
    sku: '03-225',
    img: `${process.env.PUBLIC_URL}/cart-part-images/shared/lsv-kit/lsv-kit.png`,
    price: 400.00,
    retailPrice: 1.00,
}

const LsvKit_2025: Product = {
    id: 1,
    name: 'LSV Kit',
    sku: '03-166',
    img: `${process.env.PUBLIC_URL}/cart-part-images/shared/lsv-kit/lsv-kit.png`,
    price: 400.00,
    retailPrice: 1.00,
}

const LsvKit_2023: Product = {
    id: 1,
    name: 'LSV Kit',
    sku: '03-166',
    img: `${process.env.PUBLIC_URL}/cart-part-images/shared/lsv-kit/lsv-kit.png`,
    price: 400.00,
    retailPrice: 1.00,
}

const LsvKit_None: Product = {
    id: 2,
    name: 'No LSV Kit',
    sku: 'None',
    img: `${process.env.PUBLIC_URL}/display-order/no-option.png`,
    price: 0.00,
    retailPrice: 0.00,
}

const LsvKit_2025Preassembled: Product = {
    ...LsvKit_2025,
    price: 550.00
}

const LsvKit_2024Preassembled: Product = {
    ...LsvKit_2025, // Using 2025 LSV kit for late years on 2024 earlier 2024 models use 03-225
    price: 550.00
}

const LsvKits_2024: Product[] = [
    LsvKit_2025, // Using 2025 LSV kit for late years on 2024 earlier 2024 models use 03-225
    LsvKit_None
]

const LsvKits_2024Preassembled: Product[] = [
    LsvKit_2024Preassembled, // Using 2025 LSV kit for late years on 2024 earlier 2024 models use 03-225
    LsvKit_None
]

const LsvKits_2025: Product[] = [
    LsvKit_2025,
    LsvKit_None
]

const LsvKits_2025Preassembled: Product[] = [
    LsvKit_2025Preassembled,
    LsvKit_None
]

const LsvKits_2023: Product[] = [
    LsvKit_2023,
    LsvKit_None
]

export {
    LsvKit_2024,
    LsvKit_2025,
    LsvKit_2023,
    LsvKit_None,
    LsvKits_2024,
    LsvKits_2024Preassembled,
    LsvKits_2025,
    LsvKits_2025Preassembled,
    LsvKits_2023
};